/*
 * Broadcast owns the cart when its native drawer is enabled.
 * Boost's documented customization entry point runs before widget initialization.
 * Keep Boost search, filtering and recommendations configured as they are.
 */
(function () {
  if (window.__burdlifeBoostCartCustomizationLoaded) return;
  window.__burdlifeBoostCartCustomizationLoaded = true;

  function useNativeCart() {
    if (!document.querySelector('[data-cart-drawer]')) return;
    const cartSettings = window.boostSDAppConfig?.themeSettings?.cart;
    if (cartSettings) cartSettings.enableCart = false;
  }

  window.__BoostCustomization__ = (window.__BoostCustomization__ || []).concat([useNativeCart]);
  useNativeCart();
})();
